<template>
    <mu-dialog :width="dialogWidth" :open.sync="openLoading" class="loading" :esc-press-close="false" :overlay-close="false">
        <mu-circular-progress color="primary" :stroke-width="1" :size="30"></mu-circular-progress>
        <p v-if="messagePrint">{{ messagePrint }}</p>
    </mu-dialog>
</template>

<script>
    export default {
        name: 'loading-dialog',

        // ╔═╗╦═╗╔═╗╔═╗╔═╗
        // ╠═╝╠╦╝║ ║╠═╝╚═╗
        // ╩  ╩╚═╚═╝╩  ╚═╝

        props: ['message', 'visible', 'width'],

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Retorna a mensagem enviada pelo parametro
             */
            messagePrint () {
                return this.message || ''
            },

            /**
             * Habilita ou desabilita o loading
             */
            openLoading () {
                return !!this.visible
            },

            /**
             * Define a largura do loading
             */
            dialogWidth () {
                return (this.width ? this.width : 360)
            }
        }
    }
</script>

<style lang="stylus" scoped>

    .loading
        text-align center
        p
            font-size 12px
            margin 0

</style>
